<template>
  <div>
    <span v-for="(location, idx) in locations" :key="location.id">
      <object-link
        v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOCATIONS)"
        :object="location"
      />
      <span v-else>{{ $objectDenomination(location) }}</span>
      {{ locations.length - 1 > idx ? "," : " " }}<br />
    </span>
  </div>
</template>

<script>
import formMixin from "@/mixins/form-mixin";

export default {
  name: "locations",

  components: {},

  mixins: [formMixin],

  props: {
    locations: {
      type: Array,
      default: () => [],
      description: "Locations",
    },
  },

  data() {
    return {};
  },

  setup() {},

  created() {},

  methods: {},

  watch: {
    locations(locations) {},
  },
};
</script>
